import { writable, derived } from 'svelte/store';
export const info_client = writable({});
export const client = writable({});
export const filter_list_for_curator = writable({});
export const push_button_message = writable(false);
// Access Token
export const access_token = writable('');
export const is_show_copy_comment_tooltip = writable(false);
export const is_show_copy_telegram_id_tooltip = writable(false);
// global list 
export const list = writable([]);
export const pagination = writable(null);
export const countByGroup = writable(null);
export const isHaveNews = derived(list, $list => !!$list.length);
// Global search
export const globalSearch = writable('');
export const isShowSearchLoader = writable(true);
export const searchTitle = writable('');
export const isDirtySearch = writable(false);
export const groups = writable([]);
export const tags = writable([]);
export const activeTags = writable([]);
export const flowId = writable(0);
export const ordering = writable('');
